/**
 * Opens the Transfers drawer from a surface outside it and counts where from — `feature:storage_transfer_action
 * { action: 'panel_open', source }` (the toast's "View transfers", the Home card, the Connections dialog card). The
 * status-bar chip keeps its own `ui:transfers_chip_open`.
 */
import { useTransfersPanelStore, type TransfersPanelSource } from '../store/transfersPanelStore';
import { trackTransferEvent } from './transfersApi';

export function openTransfersPanel(source: Extract<TransfersPanelSource, 'toast' | 'home' | 'connections_dialog'>): void {
  trackTransferEvent('feature:storage_transfer_action', { action: 'panel_open', source });
  useTransfersPanelStore.getState().show(source);
}
